import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "utils/useAuth/useAuth";
import { checkNonMoneyDataForTable } from "utils/utils";

const PAYFAC_PREFIX_LABEL_KEY = "common.payfac";

export const usePayfacPrefixMeta = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  return useMemo(
    () => ({
      isSuperAdmin: user?.role === "SUPER_ADMIN",
      label: t(PAYFAC_PREFIX_LABEL_KEY),
    }),
    [t, user?.role],
  );
};

export const usePayfacPrefixColumn = ({ index } = {}) => {
  const { isSuperAdmin, label } = usePayfacPrefixMeta();

  return useMemo(
    () => (isSuperAdmin ? [{
      ...(typeof index === "number" ? { index } : {}),
      key: "payfacPrefix",
      title: label,
      sorter: false,
      render: (data) => {
        return checkNonMoneyDataForTable(data, "payfacPrefix");
      },
    }] : []),
    [index, isSuperAdmin, label],
  );
};
